module.exports = __webpack_public_path__ + "static/media/NellisAuction-white-trans.b820ab08.png";